import { http } from "@/utils/http";
import { toQueryString } from "@/utils/live";
import axios from "axios";
import { getToken } from "@/utils/auth";
import { HTTP_HEADERS } from "@/config/httpHead";

/** 根据用户ID获取我的音色列表（POST） */
export const findWDVoiceProfileListByUseId = async (data?: any) => {
  const params = data ? `?${toQueryString(data)}` : "";
  return await http.post<any, any>(
    `/audio/findWDVoiceProfileListByUseId${params}`
  );
};

/** 获取直播间公共音色列表（POST） */
export const liveVoiceUserList = async (data?: any) => {
  const params = data ? `?${toQueryString(data)}` : "";
  return await http.post<any, any>(`/audio/liveVoiceUserList${params}`);
};

/** 获取音频分类及数量（POST） */
export const getCategoryCountVoiceProfileListNum = async (params: {
  voiceName?: string;
  language?: string;
}) => {
  const query = params ? `?${toQueryString(params)}` : "";
  return await http.post<any, any>(
    `/audio/categoryCountVoiceProfileListNum${query}`
  );
};

/** 根据用户ID获取语音列表（POST） */
export const findVoiceProfileListByUseId = async (data?: any) => {
  const params = data ? `?${toQueryString(data)}` : "";
  return await http.post<any, any>(
    `/audio/findVoiceProfileListByUseId${params}`
  );
};

/** 上传音频识别并且生成音色（POST） 这个接口好像有问题上传识别不了FormData 所以用axios上传*/
// export const voiceAsrAndCosyVoice = async (data?: any) => {
//   return await http.post<any, any>(
//     "/audio/voiceAsrAndCosyVoice",
//     data
//   );
// };

/** 直接使用axios上传文件（避开http封装） */
export const uploadVoiceFile = async (formData: FormData) => {
  const token = getToken();
  // 添加token认证头，但不手动设置Content-Type
  return await axios.post(
    `${HTTP_HEADERS.Http}/audio/voiceAsrAndCosyVoice`,
    formData,
    {
      headers: {
        Authorization: token,
        "X-Access-Token": token
      }
    }
  );
};

/** 添加音色 */
export const addVoice = async (data?: any) => {
  return await http.post<any, any>(`/audio/addVoice`, {
    data
  });
};

/** 更新音色 */
export const updateVoiceById = async (data?: any) => {
  return await http.post<any, any>(`/audio/updateVoiceById`, {
    data
  });
};

/** 删除音色 */
export const deleteVoiceById = async (id: string) => {
  return await http.delete<any, any>(`/audio/deleteById/${id}`);
};

/** 根据URL获取音频名字 */
export const findVoiceByUrl = async (url: string) => {
  const params = `?url=${encodeURIComponent(url)}`;
  return await http.post<any, any>(`/audio/findVoiceByUrl${params}`);
};

/** 语音合成API - 支持单个或多个音频URL */
export const synthesizeVoiceAPI = async (
  audioUrls: string | string[],
  text: string,
  voiceText: string,
  language: string
) => {
  const formData = new FormData();

  // 处理音频URL：如果是数组则用\\\ (三个反斜杠)拼接，如果是字符串则直接使用
  let urlParam: string;
  if (Array.isArray(audioUrls)) {
    urlParam = audioUrls.join("\\\\\\");
  } else {
    urlParam = audioUrls;
  }

  formData.append("voiceUrls", urlParam);
  formData.append("text", text);
  formData.append("voiceText", voiceText);
  formData.append("language", language);

  const token = getToken();
  return await axios.post(`${HTTP_HEADERS.Http}/audio/indexTts`, formData, {
    headers: {
      Authorization: token,
      "X-Access-Token": token
    }
  });
};

/**
 * 收藏音色
 */
export const collectVoice = async (voiceId: string) => {
  return await http.post<any, any>(`/collect/add/${voiceId}`);
};

/**
 * 取消收藏音色
 */
export const cancelCollectVoice = async (voiceId: string) => {
  return await http.post<any, any>(`/collect/cancel/${voiceId}`);
};

/**
 * 音色上传头像
 */
export const uploadAvatar = async (voiceId: string, file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  const token = getToken();
  return await axios.post(
    `${HTTP_HEADERS.Http}/audio/uploadAvatar/${voiceId}`,
    formData,
    {
      headers: {
        Authorization: token,
        "X-Access-Token": token
      }
    }
  );
};
